module.exports = __webpack_public_path__ + "img/carousel-back--orange.cd89cfa7.svg";